import React from "react";
import './Tos.scss';

export default function Tos() {
  return <p className="tos">
    By creating an account you agree to our <a target={"_blank"} href={"/menu/usagePolicy/view.do"} rel="noreferrer">Terms of Service</a>.
    Read our <a target={"_blank"} href={"/menu/privacyPolicy/view.do"} rel="noreferrer">Privacy Policy</a>.
  </p>
}
